import { Stack, Typography } from '@mui/material';
import {
  LANDING_PAGE_LOGO_HEIGHT_MAX,
  LANDING_PAGE_LOGO_HEIGHT_MIN,
} from '@provision/landing-page-utils';
import { Controller, useFormContext } from 'react-hook-form';
import { ColorPickerField } from 'src/pages/Settings/memberships/components/color-picker-field';
import { PixelSliderField } from 'src/pages/Settings/memberships/components/landing-page-tab/pixel-slider-field';
import { type LandingPageFormValues } from 'src/pages/Settings/memberships/components/landing-page-tab/types';
import { panelFieldLabelSx } from 'src/pages/Settings/memberships/styles';
import { COLOR_FIELD_RULES } from 'src/pages/Settings/memberships/utils/color-field-rules';

const HEADER_NOTE =
  'Leave a color empty to keep the default. Text picks light or dark on its own unless you set it.';

interface HeaderSettingsFieldsProps {
  readOnly: boolean;
}

export const HeaderSettingsFields = ({ readOnly }: HeaderSettingsFieldsProps) => {
  const { control } = useFormContext<LandingPageFormValues>();

  return (
    <Stack gap={1}>
      <Typography variant="caption" sx={panelFieldLabelSx}>
        Header
      </Typography>

      <PixelSliderField
        name="settings.logoHeight"
        label="Logo height"
        min={LANDING_PAGE_LOGO_HEIGHT_MIN}
        max={LANDING_PAGE_LOGO_HEIGHT_MAX}
        readOnly={readOnly}
      />

      <Stack sx={{ '& > *': { borderBottom: 1, borderColor: 'divider' } }}>
        <Controller
          name="settings.headerBackgroundColor"
          control={control}
          rules={COLOR_FIELD_RULES}
          render={({ field, fieldState }) => (
            <ColorPickerField
              field={field}
              label="Background"
              readOnly={readOnly}
              hasError={Boolean(fieldState.error)}
            />
          )}
        />
        <Controller
          name="settings.headerTextColor"
          control={control}
          rules={COLOR_FIELD_RULES}
          render={({ field, fieldState }) => (
            <ColorPickerField
              field={field}
              label="Text"
              readOnly={readOnly}
              hasError={Boolean(fieldState.error)}
            />
          )}
        />
      </Stack>

      <Typography variant="body2" color="text.secondary">
        {HEADER_NOTE}
      </Typography>
    </Stack>
  );
};
